import { render, staticRenderFns } from "./StudentPolicies.vue?vue&type=template&id=a8f84484&"
import script from "./StudentPolicies.vue?vue&type=script&lang=js&"
export * from "./StudentPolicies.vue?vue&type=script&lang=js&"
import style0 from "./StudentPolicies.vue?vue&type=style&index=0&id=a8f84484&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports